// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import AMap from 'vue-amap'
import { Toast, MessageBox, InfiniteScroll } from 'mint-ui'
// import 'mint-ui/lib/style.css'
import App from './App'
import router from './router'
import './style/base.css'
import './style/iconfont.css'
import Convert from './util/convert'
import Filter from './util/timeFilter'

Vue.use(AMap)
Vue.component(Toast.name, Toast)
Vue.component(MessageBox.name, MessageBox)
Vue.use(InfiniteScroll)
Vue.prototype.$Toast = Toast
Vue.prototype.$MessageBox = MessageBox

Vue.config.productionTip = false

window.homeFirst = true

// 初始化vue-amap
AMap.initAMapApiLoader({
  // 申请的高德key
  key: 'f0969b19a2bebb064ae041c0e70d82d2',
  // 插件集合
  // plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
  plugin: ['AMap.Geolocation'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})

// 路由拦截
router.beforeEach((to, from, next) => {
  let ug = navigator.userAgent.toLowerCase()
  let mob = ug.match(/Mobile/i) && ug.match(/Mobile/i)[0] === 'mobile'
  let micro = ug.match(/MicroMessenger/i) && ug.match(/MicroMessenger/i)[0] === 'micromessenger'
  // Vue.prototype.$weixin = mob && micro

  if (to.path === '/notWX' || to.path === '/fault') {
    next()
  } else {
    // // 判断每个路由进来的时候, 是不是微信打开
    if (mob && micro) {
      // 微信里打开
      // console.log('微信true')
      if (to.path === '/notWX' || to.path === '/fault') {
        next()
      } else {
        if (/\?[\S]*#\//.test(location.href)) {
          if (to.matched.some(res => res.meta.requireAuth)) { // 判断是否需要登录权限
            if (localStorage.getItem('token')) { // 判断是否登录
              next()
            } else { // 没登录则跳转到登录界面
              next({
                path: '/login'
              })
            }
          } else {
            next()
          }
        } else {
          next({
            path: '/fault'
          })
        }
      }
    } else {
      next({
        path: '/notWX'
      })
    }
  }
})

// 过滤器
for (let filter in Filter) {
  Vue.filter(filter, Filter[filter])
}

Vue.prototype.convert = Convert

Vue.config.devtools = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js